<template>
  <a-layout id="register">
    <!-- 美化弹窗组件 -->
    <BeautyModal
      :visible="modalVisible"
      :type="modalType"
      :title="modalTitle"
      :message="modalMessage"
      :extraInfo="modalExtraInfo"
      :confirmText="modalConfirmText"
      @confirm="handleModalConfirm"
      @close="handleModalClose"
    />
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content class="registerBody" style="display: flex; justify-content: center; align-items: center; min-height: calc(100vh - 60px);">
      <div class="right" style="width: 400px; max-width: 90%;">
                        <h1>{{ $t('register.welcome_to_platform') }}</h1>
        <a-tabs default-active-key="2">
          <!-- 手机号码注册功能已注释
          <a-tab-pane :title="$t('register.phone_number')" key="1">
            <div class="label">
              <p class="color-gray">{{ $t('register.phone_number') }}</p>
              <a-input class="input" v-model="phone" :placeholder="$t('login.enter_phone')" @change="checkPhone">
                <template #prefix v-if="phone.length != 0">
                  <a-trigger position="bottom" :popup-translate="[170, 10]" trigger="hover">
                    <div class="area">
                      <span class="area-num">{{ code }}</span>
                      <icon-caret-down/>
                    </div>
                    <template #content>
                      <div class="areaWarp">
                        <a-input-search class="searchInput" :placeholder="$t('common.search')"></a-input-search>
                        <a-scrollbar class="areaList">
                          <div class="areaItem"
                               :class="code == item.dialingCode ? 'areaSelected' : ''"
                               v-for="(item,index) in country" :key="index" @click="countryOk(item)">
                            <span class="color-black mr-10">{{ item.cnName }}</span>
                            <span class="color-black">{{ item.dialingCode }}</span>
                          </div>
                        </a-scrollbar>
                      </div>
                    </template>
                  </a-trigger>
                </template>
                <template #append>
                  <span @click="getVcode">{{ $t('login.t42') }}</span>
                </template>
              </a-input>
            </div>
            <div class="label">
              <p class="color-gray">{{ $t('register.password') }}</p>
              <a-trigger position="br" :popup-translate="[0, 5]" trigger="focus" :unmount-on-close="false">
                <a-input-password class="input" :placeholder="$t('register.set_password')" v-model="password"
                                  @change="checkPassword"/>
                <template #content>
                  <div class="passwordTips">
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_length') }}</span>
                    </div>
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_number') }}</span>
                    </div>
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_uppercase') }}</span>
                    </div>
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_special') }}</span>
                    </div>
                  </div>
                </template>
              </a-trigger>
            </div>
          </a-tab-pane>
          -->
          <a-tab-pane :title="$t('register.email')" key="2">
            <!-- 邮箱输入区域容器 -->
            <div class="email-section">
              <div class="email-container">
                <!-- 邮箱地址输入 -->
                <div class="label email-label">
                  <div class="label-header">
                    <icon-email class="label-icon"/>
                    <p class="label-text">{{ $t('register.email') }}</p>
                  </div>
                  <div class="input-wrapper">
                    <a-input 
                      id="register-email"
                      name="email"
                      class="input email-input" 
                      v-model="email" 
                      :placeholder="$t('register.enter_email')" 
                      @change="checkEmail"
                      @focus="onEmailFocus"
                      @blur="onEmailBlur">
                      <template #prefix>
                        <icon-email class="input-prefix-icon"/>
                      </template>
                <template #append>
                        <div class="verify-code-btn" @click="getVcode" :class="{ 'disabled': !email || is_email || countdown > 0 || sendingCode }">
                          <icon-send class="btn-icon" :class="{ 'spinning': sendingCode }"/>
                                                  <span v-if="countdown === 0 && !sendingCode">{{ $t('register.get_code') }}</span>
                        <span v-else-if="sendingCode">{{ $t('register.sending') }}</span>
                        <span v-else>{{ countdown }}{{ $t('register.countdown') }}</span>
                        </div>
                      </template>
                    </a-input>
                  </div>
                </div>
                
                <!-- 网络状态检测 -->
                <div v-if="showNetworkStatus" class="network-status">
                  <div class="status-indicator" :class="networkStatus">
                    <icon-wifi v-if="networkStatus === 'online'" class="status-icon"/>
                    <icon-close v-else-if="networkStatus === 'offline'" class="status-icon"/>
                    <icon-loading v-else class="status-icon"/>
                  </div>
                  <span class="status-text">{{ networkStatusText }}</span>
                  <a-button 
                    size="mini" 
                    type="text" 
                    @click="testConnection"
                    :loading="networkStatus === 'testing'">
                    {{ $t('register.recheck') }}
                  </a-button>
                </div>
                
                <!-- 邮箱验证码输入 -->
                <div class="label verification-label">
                  <div class="label-header">
                    <icon-safe class="label-icon"/>
                    <p class="label-text">{{ $t('register.email_verification_code') }}</p>
                  </div>
                  <div class="input-wrapper">
                    <a-input 
                      class="input verification-input" 
                      v-model="vcode" 
                      :placeholder="$t('register.enter_six_digit_code')" 
                      maxlength="6"
                      @change="checkVcode">
                      <template #prefix>
                        <icon-safe class="input-prefix-icon"/>
                </template>
              </a-input>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="label password-label">
              <p class="color-gray">{{ $t('register.password') }}</p>
              <a-trigger position="br" :popup-translate="[0, 5]" trigger="focus" :unmount-on-close="false">
                <a-input-password class="input" :placeholder="$t('register.set_password')" v-model="password"
                                  @change="checkPassword"/>
                <template #content>
                  <div class="passwordTips">
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_length') }}</span>
                    </div>
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_number') }}</span>
                    </div>
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_uppercase') }}</span>
                    </div>
                    <div class="cell">
                      <div class="checkbox"></div>
                      <span>{{ $t('register.password_special') }}</span>
                    </div>
                  </div>
                </template>
              </a-trigger>
            </div>
          </a-tab-pane>
        </a-tabs>
        <div class="label">
          <p class="color-gray font-12 invaite_t" @click="invaiteShow = !invaiteShow">
                            {{ $t('register.invite_code_optional') }}
            <icon-down :class="{ 'rotated': invaiteShow }"/>
          </p>
          <!-- 当展开时显示输入框 -->
          <a-input 
            class="input" 
            v-model="invaiteCode" 
                            :placeholder="$t('register.enter_invite_code')" 
            v-if="invaiteShow"
            :disabled="!!$route.query.inviteCode"
            :style="{ opacity: $route.query.inviteCode ? 0.7 : 1 }">
            <template #suffix v-if="$route.query.inviteCode">
                              <span style="color: #52c41a; font-size: 12px;">{{ $t('register.auto_filled') }}</span>
            </template>
          </a-input>
        </div>
        <!-- 替换原a-checkbox为自定义checkbox -->
        <div class="ruleCheckBoxWrap" @click="agree = !agree">
          <div class="custom-checkbox" :class="{ checked: agree }">
            <svg v-if="agree" width="16" height="16" viewBox="0 0 16 16">
              <polyline points="4,9 7,12 12,5" fill="none" stroke="#246bfd" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="ruleCheckText">
          {{ $t('register.agreement_prefix') }}
          <a href='#'>《{{ $t('register.user_agreement') }}》</a>
          {{ $t('register.and') }}
          <a href='#'>《{{ $t('register.privacy_policy') }}》</a>
          </span>
        </div>
        <a-button class="registerBtn" @click="login" :class="{ 'disabled': !agree }">
                          {{ $t('register.create_account') }}
        </a-button>
        <!-- 谷歌登录功能已注释
        <div class="other">
                      <a-divider orientation="center">{{ $t('register.or_login_via') }}</a-divider>
          <a-button class="googleButton">
            <img src="@/assets/googleIcon.svg" alt="">
                          {{ $t('register.continue_with_google') }}
          </a-button>
        </div>
        -->
        <div class="row">
          <div class="item">
            <span class="color-black">{{ $t('register.have_account') }}<strong class="color-primary" @click="toLogin" style="cursor: pointer;">{{ $t('register.go_login') }}</strong> </span>
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import common from '@/common/api/common.js';
import country from '../../common/area';
import util from "@/common/util";
import {mapState, mapMutations} from 'vuex';
import config from '@/common/api/config'; // 修复导入路径
import BeautyModal from '@/components/BeautyModal/BeautyModal.vue';

export default {
  name: "LoginView",
  components: {PageNav, BeautyModal},
  data() {
    return {
      country: country.countryList,
      code: '+86',
      invaiteShow: false,
      vcode: '',
      is_vcode: false,
      showCountry: false,
      phone: '',
      is_phone: false,
      email: '',
      is_email: false,
      password: '',
      is_password: false,
      invaiteCode: '',
      type: 2, // 默认使用邮箱注册（手机注册已注释）
      agree: false, // 协议勾选状态，改为布尔值
      countdown: 0, // 验证码倒计时
      showNetworkStatus: false, // 控制网络状态检测的显示
      networkStatus: 'offline', // 网络状态：online, offline, testing
      networkStatusText: '网络连接异常，请检查网络', // 网络状态文本
      sendingCode: false, // 验证码发送状态
      // 弹窗相关数据
      modalVisible: false,
      modalType: 'info',
      modalTitle: '',
      modalMessage: '',
      modalExtraInfo: '',
      modalConfirmText: '确定',
    }
  },
  mounted() {
    // 处理邀请码参数 - 支持多种参数名
    let code = this.$route.query['inviteCode'] || this.$route.query['invaite-code'] || this.$route.query['invite-code'];
    if (code) {
      console.log('🎯 检测到邀请码:', code);
      this.invaiteCode = code; // 直接设置到输入框
      this.invaiteShow = false; // 不展开邀请码输入框，保持折叠状态
      this.$util.setCache('invaite-code', code);
    }
    
    // 开发环境提示 - API响应处理修复
    if (process.env.NODE_ENV === 'development') {
      console.log('📧 注册页面已加载，API响应处理已优化');
      console.log('📧 现在支持以下响应格式:');
      console.log('   ✅ { success: true }');
      console.log('   ✅ { success: function() { return true } }');
      console.log('   ✅ { code: 200 }');
      console.log('   ✅ { status: "success" }');
      console.log('   ✅ { data: {...} } (无错误信息时)');
      console.log('');
      console.log('📋 用户交互修复:');
      console.log('   ✅ 协议勾选框已修复 (v-model绑定)');
      console.log('   ✅ "去登录"链接已修复 (添加点击事件)');
      console.log('   ✅ 协议状态现在是布尔值类型');
      console.log('   ✅ 暗色主题下checkbox可见性已修复');
      console.log('   ✅ 黑夜模式闪白问题已修复');
      console.log('');
      console.log('🎨 样式修复详情:');
      console.log('   🌙 暗色主题: 蓝绿色边框+渐变背景+发光效果');
      console.log('   ☀️ 浅色主题: 品牌色边框+适当透明度');
      console.log('   ✨ 勾选状态: 白色图标+增强阴影+缩放动画');
      console.log('   🔗 协议链接: 品牌色+悬停效果+文字阴影');
      console.log('');
      console.log('⚡ 性能优化:');
      console.log('   🚀 HTML预设主题，零闪白');
      console.log('   🔄 移除500ms延迟，即时加载');
      console.log('   💾 智能缓存同步，避免重复设置');
      console.log('   🎭 平滑过渡动画，提升体验');
      console.log('');
      console.log('📧 邮箱区域美化:');
      console.log('   🎨 居中容器设计，视觉聚焦');
      console.log('   ✨ 玻璃拟态效果，现代科技感');
      console.log('   🌊 流光动画背景，动态交互');
      console.log('   📱 完全响应式设计，移动端友好');
      console.log('   🔒 安全验证视觉，用户信任');
      console.log('');
      console.log('📐 注册页面布局优化:');
      console.log('   📏 紧凑间距设计，完整显示');
      console.log('   📱 多级响应式，适配各种屏幕');
      console.log('   🚫 移除滚动条，避免页面滚动');
      console.log('   ⚡ 性能优化，减少不必要的动画');
      console.log('   🎯 视觉层次清晰，用户体验佳');
      console.log('');
      console.log('🎯 紧凑布局优化:');
      console.log('   📦 大幅缩小间距，一屏完整显示');
      console.log('   🚫 移除滚动条，避免页面滚动');
      console.log('   📐 优化元素尺寸，保持美观紧凑');
      console.log('   ⚡ 减少动画效果，提升性能');
      console.log('   🎨 保持视觉层次，用户体验佳');
      console.log('');
      console.log('🎨 标题和邮箱标签样式优化:');
      console.log('   📍 标题完美居中显示');
      console.log('   🎯 添加标题装饰线条效果');
      console.log('   📧 邮箱标签特殊渐变背景设计');
      console.log('   ✨ 邮箱图标浮动动画效果');
      console.log('   🌟 悬停发光边框和阴影效果');
      console.log('   🎭 文字渐变和缩放动画');
      console.log('');
      console.log('📋 当前协议状态:', this.agree);
      
      // 监听协议状态变化
      this.$watch('agree', (newVal, oldVal) => {
        console.log('📋 协议状态变化:', oldVal, '->', newVal);
        if (newVal) {
          console.log('✅ 用户已同意协议 - 现在可以看到清晰的勾选状态');
        } else {
          console.log('❌ 用户取消协议 - checkbox显示为空但边框清晰可见');
        }
      });
    }
  },
  computed: {
    ...mapState(['config'])
  },
  methods: {
    ...mapMutations(['userLogin']),
    toLogin() {
      console.log('🔄 跳转到登录页面');
      this.$router.push("/login");
    },
    loginType(k) {
      this.type = k
    },
    checkPhone() {
      this.is_phone = !util.validatePhoneNumber(this.code + this.phone)
    },
    checkEmail() {
      this.is_email = !util.validateEmail(this.email)
    },
    onEmailFocus() {
      // 邮箱输入框获得焦点时的处理
      console.log('Email input focused');
    },
    onEmailBlur() {
      // 邮箱输入框失去焦点时的处理
      this.checkEmail();
    },
    checkPassword() {
      let len = this.password.length
      this.is_password = !(len >= 8 && len <= 64)
    },
    checkVcode() {
      let len = this.vcode.length
      this.is_vcode = !(len === 6 && /^\d{6}$/.test(this.vcode))
    },
    
    // 统一的API响应处理帮助方法
    isApiSuccess(response) {
      if (!response) {
        console.warn('📧 API响应为空:', response);
        return false;
      }
      
      // 在开发环境下输出详细的响应信息
      if (process.env.NODE_ENV === 'development') {
        console.log('📧 API响应分析:', {
          response: response,
          'response.success': response.success,
          'typeof response.success': typeof response.success,
          'response.code': response.code,
          'response.status': response.status,
          'response.data': response.data,
          'response.message': response.message || response.msg || response.error
        });
      }
      
      // 检查各种可能的成功标识
      if (response.success === true || response.success === 1) {
        console.log('📧 通过 success === true 判断为成功');
        return true;
      }
      
      if (typeof response.success === 'function') {
        try {
          const result = response.success();
          console.log('📧 通过 success() 函数调用结果:', result);
          return result;
        } catch (error) {
          console.warn('📧 调用 response.success() 出错:', error);
          return false;
        }
      }
      
      if (response.code === 200 || response.code === 0 || response.code === '200') {
        console.log('📧 通过 code 判断为成功:', response.code);
        return true;
      }
      
      if (response.status === 200 || response.status === 'success' || response.status === 'ok') {
        console.log('📧 通过 status 判断为成功:', response.status);
        return true;
      }
      
      // 如果没有明确的错误信息，且有数据返回，可能也是成功的
      if (!response.error && !response.message && response.data) {
        console.log('📧 通过数据存在且无错误信息判断为成功');
        return true;
      }
      
      console.log('📧 所有成功条件都不满足，判断为失败');
      return false;
    },
    
    // 获取API响应的错误信息
    getApiErrorMessage(response, defaultMessage = null) {
      if (!defaultMessage) {
        defaultMessage = this.$util.getI18nText('operation_failed_retry', 'Operation failed, please try again');
      }
      if (!response) {
        return defaultMessage;
      }
      
      return response.message || 
             response.msg || 
             response.error || 
             response.error_message ||
             response.errorMessage ||
             defaultMessage;
    },
    
    async getVcode() {
      // 检查倒计时状态和发送状态
      if (this.countdown > 0 || this.sendingCode) {
        return;
      }
      
      // 邮箱验证
      this.checkEmail()
      if (this.is_email || !this.email) {
        this.$message.warning(this.$t('register.enter_email'));
        return
      }

      // 设置发送状态
      this.sendingCode = true;

      try {
        console.log('📧 开始发送验证码到:', this.email);
        
        let res = await common.sendEmailVerifyCode(this.email)
        
        console.log('📧 验证码API响应:', res);
        
        // 检查响应格式
        if (!res) {
          throw new Error('API响应为空');
        }
        
        // 使用统一的响应处理方法
        if (this.isApiSuccess(res)) {
          this.showModal(
            'success',
            this.$t('register.code_sent_success'),
            this.$t('register.code_sent_message'),
            this.$t('register.code_sent_instruction'),
            this.$t('common.confirm')
          );
          this.startCountdown();
          
          // 发送成功时隐藏网络状态检测
          this.showNetworkStatus = false;
        } else {
          // 显示具体的错误信息
          const errorMsg = this.getApiErrorMessage(res, '发送失败，请重试');
          console.error('📧 验证码发送失败:', res);
          this.showModal(
            'error',
            this.$t('register.send_failed'),
            errorMsg,
            this.$t('register.check_email_format'),
            this.$t('common.retry')
          );
        }
      } catch (error) {
        console.error('📧 验证码发送异常:', error);
        
        // 显示网络状态检测
        this.showNetworkStatus = true;
        this.networkStatus = 'offline';
        this.networkStatusText = '网络连接异常，请检查网络';
        
        // 根据错误类型提供不同的提示信息
        let errorMessage = '网络错误，请重试';
        
        if (error.message) {
          if (error.message.includes('网络连接失败')) {
            errorMessage = '网络连接失败，请检查网络连接';
          } else if (error.message.includes('API错误')) {
            errorMessage = `服务器错误: ${error.message}`;
          } else if (error.message.includes('timeout')) {
            errorMessage = '请求超时，请检查网络连接后重试';
          } else {
            errorMessage = `请求失败: ${error.message}`;
          }
        }
        
        this.showModal(
          'error',
          this.$t('register.network_error'),
          errorMessage,
          this.$t('register.network_error_message'),
          this.$t('common.retry')
        );
        
        // 开发环境下显示详细错误信息
        if (process.env.NODE_ENV === 'development') {
          console.error('详细错误信息:', {
            message: error.message,
            stack: error.stack,
            response: error.response,
            config: error.config
          });
        }
      } finally {
        // 无论成功还是失败，都重置发送状态
        this.sendingCode = false;
      }
    },
    
    // 开始倒计时
    startCountdown() {
      this.countdown = 60; // 60秒倒计时
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
          this.countdown = 0;
        }
      }, 1000);
    },

    // 旧代码注释
    /* let res

      if (this.type == 1) {
        this.checkPhone()
        if (this.is_phone) {
          return
        }
        res = await common.sendPhoneVerifyCode(this.phone, this.code)
      } else {
        this.checkEmail()
        if (this.is_email) {
          return
        }
        res = await common.sendEmailVerifyCode(this.email)
      }
      if (res.success()) {
        this.$message.info({
          content: this.$t('login.send_success'),
          showIcon: false
        })
      } else {
        this.$message.info({
          content: res.message,
          showIcon: false
        })
      } */
      
    async login() {
      console.log('🚀 开始注册流程');
      console.log('📋 当前状态:', {
        agree: this.agree,
        email: this.email,
        password: this.password ? '***已填写***' : '未填写',
        vcode: this.vcode,
        type: this.type
      });
      
      // 检查协议勾选状态
      if (!this.agree) {
        console.log('❌ 协议未勾选，阻止注册');
        this.$message.warning(this.$t('register.agree_terms_required'));
        return
      }
      
      console.log('✅ 协议检查通过，继续注册流程');
      
      const registerInfo = {
        phone: this.phone,
        email: this.email,
        password: this.password,
        type: this.type,
        vcode: this.vcode,
        invite_code: this.invaiteCode
      };
      let res;
      // 邮箱注册验证
      this.checkEmail()
      this.checkPassword()
      this.checkVcode()
      
      if (this.is_email || this.is_password || this.is_vcode) {
        if (this.is_email) {
          this.$message.error(this.$t('register.email_format_incorrect'));
        } else if (this.is_password) {
          this.$message.error(this.$t('register.password_length_error'));
        } else if (this.is_vcode) {
          this.$message.error(this.$t('register.code_format_incorrect'));
        }
          return;
        }
      
      if (!this.email || !this.password || !this.vcode) {
        this.$message.error(this.$t('register.fill_complete_info'));
        return;
      }
      
        res = await common.emailRegister(registerInfo)
        util.setCache('login_email', this.email);
      
      console.log('📧 注册API响应:', res);
      
      // 使用统一的响应处理方法
      if (this.isApiSuccess(res)) {
        this.userLogin(res.data);
        this.showModal(
          'success',
          this.$t('register.register_success'),
          this.$t('register.register_success_message'),
          this.$t('register.register_success_instruction'),
          this.$t('common.confirm')
        );
        
        // 1.5秒后自动跳转到登录页面
        setTimeout(() => {
          this.modalVisible = false;
          this.$router.push('/login');
        }, 1500);
      } else {
        const errorMsg = this.getApiErrorMessage(res, '注册失败，请重试');
        console.error('📧 注册失败:', res);
        this.showModal(
          'error',
          this.$t('register.register_failed'),
          errorMsg,
          this.$t('register.check_input_info'),
          this.$t('common.retry')
        );
      }
    },
    toRegister() {
      this.$router.push("/register");
    },
    toReset() {
      this.$router.push("/resetPass");
    },
    countryOk(e) {
      this.code = e.dialingCode
    },

    
    // 网络状态检测
    async testConnection() {
      this.networkStatus = 'testing';
      this.networkStatusText = '正在检测网络...';
      
      try {
        // 检查 fetch API 是否可用
        if (typeof fetch === 'undefined') {
          throw new Error('浏览器不支持 fetch API');
        }
        
        // 测试实际的API服务器连接
        const testUrl = `${config.BASE_URL}/api/common/config`;
        console.log('🌐 测试API连接:', testUrl);
        
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        
        const response = await fetch(testUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            group_id: 'test',
            key: 'test'
          }),
          signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        console.log('🌐 API连接测试响应:', response.status);
        
        if (response.status === 200 || response.status === 404 || response.status === 422) {
          // 200: 成功, 404/422: 服务器可达但接口可能不存在或参数错误，说明网络正常
          this.networkStatus = 'online';
          this.networkStatusText = '网络连接正常';
          this.$message.success(this.$t('register.network_retry_verification_code'));
          
          // 3秒后自动隐藏网络状态
          setTimeout(() => {
            this.showNetworkStatus = false;
          }, 3000);
        } else {
          throw new Error(`服务器响应状态: ${response.status}`);
        }
      } catch (error) {
        console.error('🌐 网络连接测试失败:', error);
        this.networkStatus = 'offline';
        
        if (error.name === 'AbortError') {
          this.networkStatusText = '连接超时，请检查网络速度';
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
          this.networkStatusText = '无法连接到服务器，请检查网络';
        } else if (error.message.includes('不支持 fetch API')) {
          this.networkStatusText = '浏览器版本过低，请升级浏览器';
        } else {
          this.networkStatusText = `连接失败: ${error.message}`;
        }
      }
    },
    // 弹窗处理方法
    showModal(type, title, message, extraInfo = '', confirmText = '确定') {
      this.modalType = type;
      this.modalTitle = title;
      this.modalMessage = message;
      this.modalExtraInfo = extraInfo;
      this.modalConfirmText = confirmText;
      this.modalVisible = true;
    },
            handleModalConfirm() {
            this.modalVisible = false;
        },
    handleModalClose() {
      this.modalVisible = false;
    }
  }
}
</script>
<style scoped>
.ruleCheckBoxWrap {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 18px;
}
.custom-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #7a8cff;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: border-color 0.2s, background 0.2s;
  box-shadow: 0 0 0 2px rgba(36,107,253,0.08);
}
.custom-checkbox.checked {
  border-color: #246bfd;
  background: #fff;
}
.custom-checkbox svg {
  display: block;
}
/* 白天模式适配 */
body:not([arco-theme='dark']) .custom-checkbox {
  background: #fff;
  border-color: #7a8cff;
}
body:not([arco-theme='dark']) .custom-checkbox.checked {
  background: #fff;
  border-color: #246bfd;
}
body:not([arco-theme='dark']) .custom-checkbox svg {
  stroke: #246bfd;
}
/* 暗色模式适配 */
body[arco-theme='dark'] .custom-checkbox {
  background: #222;
  border-color: #7a8cff;
}
body[arco-theme='dark'] .custom-checkbox.checked {
  background: #222;
  border-color: #246bfd;
}
body[arco-theme='dark'] .custom-checkbox svg {
  stroke: #fff;
}
.ruleCheckText {
  font-size: 14px;
  color: #333;
}
body[arco-theme='dark'] .ruleCheckText {
  color: #fff;
}
.ruleCheckText a {
  color: #7a8cff;
  text-decoration: underline;
  margin: 0 2px;
}
body:not([arco-theme='dark']) .ruleCheckText a {
  color: #246bfd;
}
/* 自定义注册页协议勾选框样式 */
.ruleCheck .arco-checkbox-icon {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #7a8cff;
  background: #fff;
  transition: border-color 0.2s, background 0.2s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.ruleCheck .arco-checkbox-checked .arco-checkbox-icon {
  background: #fff;
  border-color: #246bfd;
}
.ruleCheck .arco-checkbox-checked .arco-checkbox-icon::after {
  content: '';
  display: block;
  width: 10px;
  height: 6px;
  border-left: 2.5px solid #246bfd;
  border-bottom: 2.5px solid #246bfd;
  position: absolute;
  left: 3px;
  top: 3px;
  transform: rotate(-45deg);
}
.ruleCheck .arco-checkbox-icon::after {
  content: '';
  display: none;
}
.ruleCheck .arco-checkbox-checked .arco-checkbox-icon::after {
  display: block;
}
.ruleCheck .arco-checkbox {
  position: relative;
}
/* 暗色模式适配 */
body[arco-theme='dark'] .ruleCheck .arco-checkbox-icon {
  background: #222;
  border-color: #7a8cff;
}
body[arco-theme='dark'] .ruleCheck .arco-checkbox-checked .arco-checkbox-icon {
  background: #222;
  border-color: #246bfd;
}
body[arco-theme='dark'] .ruleCheck .arco-checkbox-checked .arco-checkbox-icon::after {
  border-left: 2.5px solid #fff;
  border-bottom: 2.5px solid #fff;
}

/* 强制覆盖 Arco 勾选框样式，SVG对勾方案 */
::v-deep(.ruleCheck .arco-checkbox-icon) {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #7a8cff;
  background: #fff;
  position: relative;
  transition: border-color 0.2s, background 0.2s;
}
::v-deep(.ruleCheck .arco-checkbox-checked .arco-checkbox-icon) {
  background: #fff !important;
  border-color: #246bfd !important;
  background-image: url("data:image/svg+xml;utf8,<svg width='18' height='18' xmlns='http://www.w3.org/2000/svg'><polyline points='4,10 8,14 14,6' fill='none' stroke='%23246bfd' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 14px 14px !important;
}
body[arco-theme='dark'] ::v-deep(.ruleCheck .arco-checkbox-icon) {
  background: #222 !important;
  border-color: #7a8cff !important;
}
body[arco-theme='dark'] ::v-deep(.ruleCheck .arco-checkbox-checked .arco-checkbox-icon) {
  background: #222 !important;
  border-color: #246bfd !important;
  background-image: url("data:image/svg+xml;utf8,<svg width='18' height='18' xmlns='http://www.w3.org/2000/svg'><polyline points='4,10 8,14 14,6' fill='none' stroke='%23fff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/></svg>") !important;
}

/* 强制 Arco Checkbox 勾选样式，SVG对勾+高优先级 */
::v-deep(.ruleCheck .arco-checkbox-icon) {
  width: 20px !important;
  height: 20px !important;
  border-radius: 4px !important;
  border: 2px solid #7a8cff !important;
  background: #fff !important;
  position: relative !important;
  transition: border-color 0.2s, background 0.2s !important;
  box-shadow: 0 0 0 2px rgba(36,107,253,0.08) !important;
}
::v-deep(.ruleCheck .arco-checkbox-checked .arco-checkbox-icon) {
  background: #fff !important;
  border-color: #246bfd !important;
  background-image: url("data:image/svg+xml;utf8,<svg width='18' height='18' xmlns='http://www.w3.org/2000/svg'><polyline points='4,10 8,14 14,6' fill='none' stroke='%23246bfd' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 14px 14px !important;
}
body[arco-theme='dark'] ::v-deep(.ruleCheck .arco-checkbox-icon) {
  background: #222 !important;
  border-color: #7a8cff !important;
}
body[arco-theme='dark'] ::v-deep(.ruleCheck .arco-checkbox-checked .arco-checkbox-icon) {
  background: #222 !important;
  border-color: #246bfd !important;
  background-image: url("data:image/svg+xml;utf8,<svg width='18' height='18' xmlns='http://www.w3.org/2000/svg'><polyline points='4,10 8,14 14,6' fill='none' stroke='%23fff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/></svg>") !important;
}

/* 邀请码下拉箭头旋转动画 */
.invaite_t .rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.invaite_t icon-down {
  transition: transform 0.3s ease;
}


</style>
